export default "__VITE_ASSET__DBArNx6o__"